import { FieldArray } from 'react-final-form-arrays';
import { Box, Grid } from '@mui/material';

import { Typography, TextField, ProductGroupSelectField } from '@occc-app/design-system';
import { parseNumber } from '@occc-app/lib/finalFormUtils';

export const PunchcardConfiguration = () => {
  return (
    <Box mt={2}>
      <Typography variant='subtitle1' gutterBottom>
        When They Purchase
      </Typography>
      <FieldArray name='punchcardChallenge.products'>
        {({ fields }) => {
          return (
            <>
              {fields.map((fieldArrayName) => {
                const thresholdName = `${fieldArrayName}.purchaseThreshold`;
                const thresholdLabel = 'Threshold';

                return (
                  <Box key={fieldArrayName}>
                    <Grid container spacing={3}>
                      <Grid item sm={2}>
                        <TextField
                          name={thresholdName}
                          label={thresholdLabel}
                          fieldProps={{
                            parse: parseNumber,
                          }}
                        />
                      </Grid>
                      <Grid item sm={5}>
                        <ProductGroupSelectField
                          inputProps={{
                            margin: 'none',
                          }}
                          name={`${fieldArrayName}.eligibleProductGroups`}
                          label='Product Groups (Any of Below)'
                        />
                      </Grid>
                    </Grid>
                  </Box>
                );
              })}
            </>
          );
        }}
      </FieldArray>
    </Box>
  );
};
